<template>
  <router-link
    data-testid="user-panel-link"
    class="flex h-11 w-full items-center gap-4 px-7 py-3 text-primary-600 no-underline transition-colors duration-300 hover:bg-primary-200 focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:outline-none focus-visible:ring-inset"
    to="/user-panel"
    :aria-label="$t('menu.user_panel')"
    @click="$emit('linkClicked')"
  >
    <AppIcon
      name="custom:topbar/user"
      :width="24"
      alt=""
      aria-hidden="true"
      class="size-6 min-h-6 min-w-6 shrink-0"
    />
    <p class="min-w-0 truncate whitespace-nowrap" :class="{ hidden: !hovered }">
      {{
        $keycloak?.tokenParsed?.email
          ? $keycloak.tokenParsed.email
          : $t('menu.user_panel')
      }}
    </p>
  </router-link>
  <ListBoxOrganization
    class="flex-1"
    :hovered="hovered"
    @dropdown-open="$emit('dropdownOpen')"
    @dropdown-close="$emit('dropdownClose')"
  />
  <div
    class="mb-3 flex h-11 w-full items-center gap-4 border-b border-primary-200 py-3 pr-1 pl-7 text-primary-600 transition-colors duration-300 hover:bg-primary-200"
  >
    <AppIcon
      name="custom:topbar/icon-language"
      :width="24"
      alt=""
      aria-hidden="true"
      class="size-6 min-h-6 min-w-6 shrink-0"
    />
    <ListBoxPageLang
      class="flex-1"
      :hovered="hovered"
      @dropdown-open="$emit('dropdownOpen')"
      @dropdown-close="$emit('dropdownClose')"
    />
  </div>
</template>

<script>
import ListBoxPageLang from './ListBoxPageLang.vue'
import ListBoxOrganization from './ListBoxOrganization.vue'

export default {
  name: 'UserAndLanguageMenu',
  components: {
    ListBoxPageLang,
    ListBoxOrganization,
  },
  props: {
    hovered: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['linkClicked', 'dropdownOpen', 'dropdownClose'],
}
</script>
